import { render, staticRenderFns } from "./Integer.vue?vue&type=template&id=ae806662&"
import script from "./Integer.vue?vue&type=script&lang=js&"
export * from "./Integer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae806662')) {
      api.createRecord('ae806662', component.options)
    } else {
      api.reload('ae806662', component.options)
    }
    module.hot.accept("./Integer.vue?vue&type=template&id=ae806662&", function () {
      api.rerender('ae806662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/Integer.vue"
export default component.exports